import { AiMutationKeys } from "#lib/AiQueryKeys.ts";
import { useIsMutating } from "@tanstack/react-query";

export const useIsCreateConversationMutating = () => {
    const isMutating = useIsMutating({ mutationKey: AiMutationKeys.CreateConversation() });

    return isMutating > 0;
};
